import { useMutation, useQueryClient } from 'react-query';
import { get } from 'lodash'; // Replace with your actual utility function if necessary
import { useToast } from 'src/context/ToastProvider';
import { markAttendance } from 'src/apis/offlineDrive';

export const useMarkAttendanceMutation = () => {
	const queryClient = useQueryClient();
	const toast = useToast();
	return useMutation(['markAttendance'], markAttendance, {
		onSuccess(data, variables) {
			console.log('hello');
			queryClient.refetchQueries({
				queryKey: ['getOfflineDriveCandidates'],
				exact: false,
			});
			queryClient.refetchQueries({ queryKey: ['getOfflineDrivePositions'], exact: false });
			toast({
				title: 'User marked successfully',
			});
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				type: 'error',
				title: errorMessage,
			});
		},
	});
};
